module.exports = __webpack_public_path__ + "src/images/products/prep/38_Air Oxford Shirt .png";